module.exports = __webpack_public_path__ + "static/media/1015018.9de6a2d3.jpg";